import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {RootState} from '../'

export interface AuthState {
    authenticated: boolean
    user: APICustomerUserPrincipal | null
    accessibleCustomers: CustomerAPICustomer[]
    selectedCustomer: CustomerAPICustomer | null
    permissions: string[]
    envName: ""
}

const initialState: AuthState = {
    authenticated: false,
    user: null,
    accessibleCustomers: [],
    selectedCustomer: null,
    permissions: [],
    envName: ""
}

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        changeUser: (state, action: PayloadAction<APICustomerUserPrincipal | null>) => {
            if (action.payload) {
                const customers = action.payload.customers || [];
                const selectedCustomer = customers.length > 0 ? customers[0] : null;
                state.authenticated = true;
                state.accessibleCustomers = customers;
                state.selectedCustomer = selectedCustomer;
                state.permissions = action.payload.permissions
            } else {
                state.authenticated = false;
                state.accessibleCustomers = [];
                state.selectedCustomer = null;
                state.permissions = []
            }
        },
        changeSelectedCustomer: (state, action: PayloadAction<CustomerAPICustomer | null>) => {
            state.selectedCustomer = action.payload
        }
    }
})

export const {
    changeUser,
    changeSelectedCustomer
} = authSlice.actions


export const isAuthenticatedSelector = (state: RootState): boolean => state?.auth.authenticated ?? false
export const selectedCustomerSelector = (state: RootState): CustomerAPICustomer | null => state.auth.selectedCustomer
export const accessibleCustomersSelector = (state: RootState): CustomerAPICustomer[] => state.auth.accessibleCustomers

export default authSlice.reducer
